export abstract class BasicStateAbstract {


}
